import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	// Top, About
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		component: () => import('../views/About.vue')
	},

	// Web
	{
		path: '/web01',
		name: 'web01',
		component: () => import('../views/web/web01.vue')
	},
	{
		path: '/web02',
		name: 'web02',
		component: () => import('../views/web/web02.vue')
	},
	{
		path: '/web03',
		name: 'web03',
		component: () => import('../views/web/web03.vue')
	},
	{
		path: '/web04',
		name: 'web04',
		component: () => import('../views/web/web04.vue')
	},
	{
		path: '/web05',
		name: 'web05',
		component: () => import('../views/web/web05.vue')
	},
	{
		path: '/web06',
		name: 'web06',
		component: () => import('../views/web/web06.vue')
	},
	{
		path: '/web07',
		name: 'web07',
		component: () => import('../views/web/web07.vue')
	},
	{
		path: '/web08',
		name: 'web08',
		component: () => import('../views/web/web08.vue')
	},
	{
		path: '/web09',
		name: 'web09',
		component: () => import('../views/web/web09.vue')
	},

	// Service
	{
		path: '/patrash',
		name: 'patrash',
		component: () => import('../views/service/patrash.vue')
	},
	{
		path: '/tact',
		name: 'tact',
		component: () => import('../views/service/tact.vue')
	},
	{
		path: '/kenparis',
		name: 'kenparis',
		component: () => import('../views/service/kenparis.vue')
	},
	{
		path: '/chacca',
		name: 'chacca',
		component: () => import('../views/service/chacca.vue')
	},
	{
		path: '/orikaeshi',
		name: 'orikaeshi',
		component: () => import('../views/service/orikaeshi.vue')
	},
	{
		path: '/honano',
		name: 'honano',
		component: () => import('../views/service/honano.vue')
	},
]

const router = new VueRouter({
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes
})

export default router
